<nb-card>
    <nb-card-header>
        {{title}}
    </nb-card-header>
    <ng-container *ngIf="hasValue;else spinner">
        <nb-card-body>
            <div class="form-grid-container">
                <div class="form-wrapper">
                    <ubs-ofbiz-form [ofbizForm]="addForm" [title]="title" [state]="state" [parameters]="parameters" (openDialogContainerEvent)="openDialogContainer($event)" [lookupSelectedValue]="lookupSelectedValue" [target]="target" (submitResult)="submitResult($event)"></ubs-ofbiz-form>
                </div>
            </div>
        </nb-card-body>
    </ng-container>
    <ng-template #spinner>
        <nb-card-body [nbSpinner]="true"
          nbSpinnerStatus="danger"
          nbSpinnerSize="large"
          nbSpinnerMessage="Working on it ... ">
        </nb-card-body>
      </ng-template>
</nb-card>
